import React from 'react';

import { Section } from '../Section';
import { getClassificationSettings } from 'utils/apiRequests';
import { ApLoaderDefault, ApLoaderText } from '@alixpartners/ui-components';
import { ClassificationColumns } from 'Data/components/ConfigureClassificationStep';

export const ClassificationSection = ({
	columns,
	onChange,
	animationIndex,
}) => {
	const onColumnClick = e => {
		const { name: clickedColumnName, checked: isSelected } = e.target;
		const updatedColumns = columns.map(item => {
			if (item.name === clickedColumnName) {
				return { ...item, isSelected };
			}

			return item;
		});

		onChange({ columns: updatedColumns });
	};

	return (
		<Section
			title={'Classification Columns'}
			description="Select columns that can be used to help classify the data. Note - if you select columns that contain poor or irrelevant data, the results of the classification are likely to be skewed."
			animationIndex={animationIndex}
		>
			<ClassificationColumns onChange={onColumnClick} data={columns} />
		</Section>
	);
};

export default class ClassificationSectionContainer extends React.Component {
	componentDidMount() {
		const { onChange } = this.props;

		getClassificationSettings().then(settings => {
			if (settings) {
				onChange(settings, true);
			}
		});
	}

	render() {
		const { data } = this.props;

		if (!data || data.columns.length === 0) {
			return <ApLoaderDefault loaderText={() => <ApLoaderText />} />;
		}

		return <ClassificationSection {...this.props} columns={data.columns} />;
	}
}
